module.exports = __webpack_public_path__ + "static/media/icon-down.69a5c77f.svg";